/* eslint-disable no-restricted-imports */
/* eslint-disable complexity */
import {FC, Fragment} from 'react';
import { AuthFlowAction } from '@/components/blocks/AuthentificationFlow';
import { ModalLogin } from '@/components/content/Cart/parts/ModalLogin';
import { ModalRegister } from '@/components/content/Cart/parts/ModalRegister';


type AuthFlowModalProps = {
	action: AuthFlowAction;
	onClose: () => void;
	onGo: (action: AuthFlowAction) => void;
	type?: 'login' | 'wishlist';
}

export const AuthFlowModal: FC<AuthFlowModalProps> = ({onClose, action, onGo, type}) => (
	<Fragment>
		{AuthFlowAction.LOGIN === action
			? <ModalLogin onClose={onClose} onGoRegister={() => onGo(AuthFlowAction.REGISTER)} type={type}/>
		 	: <ModalRegister onClose={onClose} onGoBack={() => onGo(AuthFlowAction.LOGIN)} />}
	</Fragment>
);
